import styled from "styled-components";

export const RouteListContainer = styled.div`
  margin: 0 -12px;
`;
export const RouteListItem = styled.a`
  padding: 12px;
  & + & {
    border-top: 1px solid #f7f8f9;
  }
  color: #010024;
  text-decoration: none;
`;
export const NamePart = styled.span`
  display: inline-block;
  font-weight: bold;
  position: relative;
  padding: 0 2px;
  & + & {
    margin-left: 14px;
  }
  & + &::after {
    content: " ";
    position: absolute;
    border-left: 1px solid #e1e5e9;
    left: -7px;
    top: -1px;
    bottom: -1px;
  }
`;

export const ContainerUpper = styled.div`
  margin: -12px -12px 12px;
  padding: 0 12px;
  background: white;
  border-bottom: 1px solid #f7f8f9;
`;

export const RouteListGroupHeader = styled.div`
  background: #f7f8f9;
  font-size: 0.95rem;
  font-weight: bold;
  padding-left: 12px;
  padding-top: 2px;
  padding-bottom: 2px;
`;
